<template>
  <div class="operation-log">
    <div class="log-title">操作日志</div>
    <a-table
      :row-key="(_, index) => index"
      :dataSource="logsTable"
      :columns="columns"
      :pagination="false"
      :scroll="{ x: '100%' }"
      class="operation-log-table"
    />
  </div>
</template>

<script setup>
import { getOperationRecords } from '@/api/patientFile'
import { ref, defineExpose } from 'vue'
import { defineProps } from 'vue'

const props = defineProps({
  orderSn: {
    type: String,
    default: ''
  }
})
const logsTable = ref([])
const columns = [
  {
    title: '处理类型',
    dataIndex: 'handleTypeName',
    key: 'handleTypeName'
  },
  {
    title: '操作时间',
    dataIndex: 'operationTime',
    key: 'operationTime'
  },
  {
    title: '操作类型',
    dataIndex: 'operationTypeName',
    key: 'operationTypeName'
  },
  {
    title: '操作人',
    dataIndex: 'operatorName',
    key: 'operatorName'
  },
  {
    title: '备注',
    dataIndex: 'remark',
    key: 'remark'
  }
]
const getLog = () => {
  logsTable.value.splice(0)
  if (!props.orderSn) return
  getOperationRecords({ orderSn: props.orderSn }).then(res => {
    logsTable.value = res
  })
}
// 导出方法
defineExpose({
  getLog
})
</script>

<style scoped lang="scss">
.operation-log {
  .log-title {
    margin-bottom: 12px;
    font-weight: 500;
  }
}
</style>
